<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    inputValue: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<template>
  <div
    :class="{
      [$style.checkboxContainer]: true,
      [$style.selected]: model.includes(inputValue),
      [$style.checkboxDisabled]: disabled,
    }">
    <input v-model="model" :disabled="disabled" type="checkbox" v-bind="$attrs" :value="inputValue" />
    <span v-show="!$attrs.disabled" :class="$style.checkmark" />
    <span v-show="!model.includes(inputValue)" :class="$style.emptyCheckmark" />
    <p class="button-text">{{ label }}</p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.checkboxContainer {
  position: relative;
  display: flex;
  flex-shrink: 0;
  max-width: 100%;
  color: $dark-gray;

  > input {
    width: 20px;
    min-width: 20px;
    height: 20px;
    margin-right: 8px;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid $dark-gray;
    border-radius: 8px;
    appearance: none;
    outline: none;

    &:checked {
      background-color: $primary-blue;
    }

    &:disabled {
      background-color: $white !important;
      border: 1px solid $white;
    }
  }

  .checkmark {
    visibility: hidden;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      pointer-events: none;
      content: '';
      background: url(~@assets/icons/DoubleCheck.svg) no-repeat center;
    }
  }

  &.selected {
    color: $primary-blue;

    > input {
      background-color: $primary-blue;
      border: 1px solid $primary-blue;

      &:disabled {
        border: 1px solid $white;
      }
    }

    > .checkmark {
      visibility: visible;
    }
  }

  > p {
    color: currentColor;
  }

  &.checkboxDisabled {
    > .checkmark {
      &::after {
        background: url(~@assets/icons/BlueDoubleCheck.svg) no-repeat center;
      }
    }

    > .emptyCheckmark {
      visibility: visible;

      &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        pointer-events: none;
        content: '';
        background: url(~@assets/icons/checkboxX.svg) no-repeat center;
      }
    }
  }
}
</style>
